<template>
  <a-drawer
    placement="left"
    :wrapClassName="
      getScreen ? 'm-drawer topnotif' : 'm-drawer m-drawer-left2x m-drawer-notif topnotif'
    "
    :mask="getScreen ? true : false"
    :closable="false"
    :width="getScreen ? 340 : 400"
    @close="handleClose"
    :visible="visible"
  >
    <div slot="title" class="m-display-flex flex-row space-between nowrap">
      <span> <a-icon type="notification" />&nbsp; Notification </span>
      <a-button-group>
        <a-button
          v-if="cleanDisplay"
          @click="handleClean"
          size="small"
          type="dash"
          icon="delete"
        >Clear</a-button>
        <!-- <a-button type="default" size="small">History</a-button> -->
        <a-button @click="handleClose" type="danger" size="small" icon="close"
          >Close</a-button
        >
      </a-button-group>
    </div>
    <div class="m-drawer-body">
      <div class="search-wrapper">
        <a-input-search
          v-model="search"
          @pressEnter="onSearch"
          placeholder="Search Notification .. "
        />
      </div>
      <a-tabs v-model="activeKey" defaultActiveKey="aksi" class="m-tabs">
        <a-tab-pane class="m-tabs-pane" key="aksi">
          <div slot="tab">
            <a-badge
              :offset="[10, -2]"
              :count="listNotif.length"
              :overflowCount="10"
              :numberStyle="{ backgroundColor: '#52c41a' }"
            >
              <span>Actions</span>
            </a-badge>
          </div>
          <a-list
            class="notif-list"
            v-if="listNotif.length > 0"
            :dataSource="listNotif"
          >
            <a-list-item
              class="padding-remove"
              slot="renderItem"
              slot-scope="item"
            >
              <a-card
                class="m-card-notif margin-bottom"
                @click="handleNotification(item)"
              >
                <div>
                  <div class="m-display-flex nowrap space-between">
                    <div>
                      <h4 class="margin-remove m-text-dots">
                        {{ item.tipe + " " + item.tlc_pembuat }}
                      </h4>
                      <a-tooltip class="m-tooltip-inner" placement="bottomLeft">
                        <template slot="title">
                          <span>{{ item.invoice_no }}</span>
                        </template>
                        <span class="m-text-dots m-text-sub">{{
                          item.invoice_no
                        }}</span>
                      </a-tooltip>
                    </div>
                    <div class="m-text-align right">
                      <a-tag color="orange" class="margin-remove">{{
                        item.aksi
                      }}</a-tag>
                    </div>
                  </div>
                  <p>Sent to you as {{ item.sebagai }}</p>
                  <span>
                    <a-icon type="clock-circle" />
                    <span class="margin-left-small">{{
                      item.waktu_notif
                    }}</span>
                  </span>
                </div>
              </a-card>
            </a-list-item>
          </a-list>
          <a-alert
            type="error"
            message="There are no notifications"
            banner
            v-else
          />
        </a-tab-pane>
        <a-tab-pane class="m-tabs-pane" key="informasi" forceRender>
          <div slot="tab">
            <a-badge
              :offset="[10, -2]"
              :count="listInfo.length"
              :overflowCount="10"
              :numberStyle="{ backgroundColor: '#52c41a' }"
            >
              <span>Information</span>
            </a-badge>
          </div>
          <template v-if="listInfo.length > 0">
            <a-card
              class="m-card-notif margin-bottom"
              v-for="info in listInfo"
              :key="info.id_notifikasi"
              @click="handleInformation(info)"
            >
              <div class="m-display-flex nowrap flex-row space-between">
                <div>
                  <h4 class="margin-remove m-text-dots">
                    {{ info.keperluan }}
                  </h4>
                  <span class="m-text-dots m-text-sub">{{
                    info.invoice_no
                  }}</span>
                </div>
                <div>
                  <!-- <a-tag
                    v-if="
                      info.c_project ||
                      (info.c_project === null &&
                        info.tipe !== 'Kas Kecil' &&
                        info.tipe !== 'Sales Notification' &&
                        info.tipe !== 'Suplier')
                    "
                    class="margin-remove"
                    >{{
                      info.c_project ? info.c_project : "Corrupted Data"
                    }}</a-tag> -->
                    <a-tag
                    v-if="info.c_project"
                    class="margin-remove"
                    >{{info.c_project}}</a-tag>
                </div>
              </div>
              <p>
                <b>{{ info.deskripsi }}</b>
                By {{ info.oleh }}
              </p>
              <span>
                <a-icon type="clock-circle" />
                {{ info.waktu_notif }}
              </span>
            </a-card>
          </template>
          <a-alert type="error" message="Tidak ada informasi" banner v-else />
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import HandleRoute from "@/mixins/HandleRoute";
import { addEventListener } from "../mixins/addEventListener";

export default {
  name: "Notification",
  mixins: [GlobalMethod, HandleRoute, addEventListener],
  props: {
    visible: Boolean,
  },
  data() {
    return {
      loading: true,
      listNotif: [],
      listInfo: [],
      activeKey: "aksi",
      search: "",
    };
  },
  watch: {
    GET_PRIVATE() {
      this.$store.dispatch("FETCH_NOTIFICATION");
      if (
        this.GET_PRIVATE.message.aksi == 2 ||
        this.GET_PRIVATE.message.aksi == 1
      ) {
        this.displayMessageValue("notify", this.GET_PRIVATE.message);
      }
    },
    "getNotification.aksi"() {
      this.onSearch();
    },
    search() {
      if (this.search == "") {
        this.onSearch();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getNotification",
      "GET_HISTORY",
      "GET_PRIVATE",
    ]),
    cleanDisplay() {
      if (this.activeKey === "informasi") {
        return true;
      } else {
        return false;
      }
    },
    notif() {
      let output = JSON.parse(JSON.stringify(this.getNotification));

      if (this.search) {
        if (this.activeKey == "aksi") {
          output.aksi = output.aksi.filter(
            (item) =>
              (item.tipe &&
                item.tipe.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.aksi &&
                item.aksi.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.sebagai &&
                item.sebagai.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.tlc_pembuat &&
                item.tlc_pembuat
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.waktu_notif &&
                item.waktu_notif
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.invoice_no &&
                item.invoice_no
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
        } else {
          output.informasi = output.informasi.filter(
            (item) =>
              (item.tipe &&
                item.tipe.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.deskripsi &&
                item.deskripsi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.invoice_no &&
                item.invoice_no
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.keperluan &&
                item.keperluan
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.oleh &&
                item.oleh.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.waktu_notif &&
                item.waktu_notif
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
        }
      }

      return output;
    },
  },
  methods: {
    ...mapActions({ FETCH_NOTIFICATION: "FETCH_NOTIFICATION" }),
    handleClose() {
      Event.$emit("notificationToggle");
    },
    fetchUserNotif() {
      this.$store.dispatch("SEND_EVENT", {
        type: "simfoniConnected",
        data: {
          tlc: this.getAuth.username,
          api: this.getAuth.apikey,
          password: this.getAuth.password,
        },
      });
    },
    handleInformation(payload) {
      if(payload.tlc_to==null){
        this.handleNotification(payload);
      }else{
        axios({
          method: "put",
          url: this.$serviceUrl + "notifikasi/aksi",
          processData: false,
          data: {
            invoice_no: payload.invoice_no,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((response) => {
          this.$store.dispatch("FETCH_NOTIFICATION");
          this.handleNotification(payload);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
      }
    },
    handleClean() {
      const that = this;
      this.$confirm({
        title: "Are you sure to clear all notification on tab information?",
        content: null,
        okText: "Yes",
        cancelText: "No",
        onOk() {
          axios({
            method: "get",
            url: that.$serviceUrl + "notifikasi/clear_all",
            processData: false,
            data: {
              tlc: that.getAuth.username,
            },
            auth: {
              username: that.getAuth.username,
              password: that.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": that.getAuth.apikey,
            },
          })
            .then((response) => {
              that.$store.dispatch("FETCH_NOTIFICATION");
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        },
        onCancel() { },
      });
    },
    onSearch() {
      this.listNotif = this.notif.aksi;
      this.listInfo = this.notif.informasi;
    },
  },
  mounted() {
    this.addEventListener("simfoniConnected", (user) => {
      this.$store.dispatch("RECEIVE_USERS", user);
    });
    this.addEventListener("notifSim", (msg) => {
      this.$store.dispatch("RECEIVE_PRIVATE", msg);
    });
    this.fetchUserNotif();
  },
};
</script>

<style>
.vb > .vb-dragger {
  z-index: 5;
  width: 12px;
  right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  background-color: rgba(48, 121, 244, 0.1);
  margin: 5px 5px 5px 0;
  border-radius: 20px;
  height: calc(100% - 10px);
  display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.3);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
}
</style>

<style lang="less" scoped>
.search-wrapper {
  padding: @padding;
  background-color: white;
}

.topnotif{
  z-index: 499!important;
}
</style>
